import { render, staticRenderFns } from "./GoogleMyBusinessImage.vue?vue&type=template&id=97538400&functional=true&"
import script from "./GoogleMyBusinessImage.vue?vue&type=script&lang=js&"
export * from "./GoogleMyBusinessImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports